module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin.1db37d94.woff";